import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { ScrollView, StyleSheet } from 'react-native';
import { getResponsivePadding, getResponsiveContainerWidth } from '../../helpers/utils';

export interface ILayout {
  title: string;
  leftButton?: JSX.Element;
  rightButton?: JSX.Element;
  scrollViewProps?: { [key: string]: any };
  showFooter?: boolean;
  children: React.ReactNode;
}

/**
 * Layout component with mobile-responsive design
 *
 * @param {ILayout} props
 * @return {React.FC}
 */
const Layout: React.FC<ILayout> = ({
  title,
  leftButton,
  rightButton,
  scrollViewProps,
  children,
  showFooter
}) => {
  const styles = createLayoutStyles();

  const defaultScrollViewProps = {
    contentContainerStyle: styles.scrollContainer,
    showsVerticalScrollIndicator: false,
    ...scrollViewProps
  };

  return (
    <>
      <Header title={title} leftButton={leftButton} rightButton={rightButton} />
      <ScrollView {...defaultScrollViewProps}>{children}</ScrollView>
      {showFooter !== false && <Footer />}
    </>
  );
};

const createLayoutStyles = () =>
  StyleSheet.create({
    scrollContainer: {
      minHeight: '100%',
      paddingHorizontal: getResponsivePadding(12, 16, 20),
      paddingVertical: getResponsivePadding(8, 12, 16),
      alignItems: 'center',
      justifyContent: 'flex-start',
      maxWidth: getResponsiveContainerWidth(),
      width: '100%',
      alignSelf: 'center'
    }
  });

export default Layout;
